import {Selector} from "../mixins/dictionaries";
import {countSelectedBases, fixedMaxValue, getRulerTickStep} from "./utils";
import {
    linearPreviewHeight,
    paddingOligoEditor as paddingEditor,
    pointerWidth
} from '../mixins/constants'

import {select, selectAll} from "d3-selection";
import {annotationPath} from "../mixins/linearShape";
import {scaleAnnotationSize} from "../editor/utils";
import {standardColoring} from "../utils/plasmid";

const d3 = {select, selectAll};

export default class sequencePreviewMap {
    constructor(mediator) {
        this.mediator = mediator;
        this.initDataContainer();
        this.setPlacements();
        this.initPreview()
    }

    initDataContainer() {
        let $activeContainer = document.querySelector(`#previewTabContent .active`);
        if (!$activeContainer) {
            $activeContainer = document.querySelector(Selector.SEQUENCE_LINEAR_MAP)
        }

        this.$activeBoxContainer = $activeContainer.getBoundingClientRect();

        this.rangeBases = {
            "start": 0,
            "end": 0,
            "length": 0
        }

        this.sourceObject = "sequence"
        this.slots = [];
    }

    initData(decodedStructuredData, sourceData) {
        this.sequenceMapped = decodedStructuredData["decodedCartoonMap"];
        this.crossMap = decodedStructuredData["decodedCrossMap"]

        this.characters = this.sequenceMapped.filter(item => !item.bond);

        this.sequenceLength = this.characters.length;
        this.fontBoxWidth = this.$activeBoxContainer.width / this.sequenceLength;

        this.slots = sourceData.slots;
    }

    initPreview() {
        this.mainBoxContainer = d3.select(Selector.SEQUENCE_LINEAR_MAP)
            .append("div")
            .append("svg")
            .style("height", `${linearPreviewHeight}px`)
            .style("width", "100%")

        this.mainContainer = this.mainBoxContainer.append("g")
            .attr("transform", `translate(0,0)`);

        this.rulerContainer = this.mainContainer.append("g")
            .attr("transform", `translate(0,${this.placements.editor.ruler})`);

        this.slotsContainer = this.rulerContainer.append("g")

        this.annotationsContainer = this.rulerContainer.append("g")

        this.pointer = this.rulerContainer
            .append("path")
            .attr("d", `M0,0L${pointerWidth},-6L${pointerWidth * 2},0z`)
            .style("fill", "#000")
            .style("stroke", "#000")
            .style("stroke-width", 1)
    }

    setPlacements() {
        this.placements = {
            editor: {
                ruler: linearPreviewHeight / 2,
                slot: -13,
                pointer: 25,
            }
        }
    }

    setData(decodedStructuredData, sourceData) {
        this.initData(decodedStructuredData, sourceData);
        this.render();

        this.EventsOn();
    }

    render() {
        this.drawSlots();
        this.renderRuler();
        this.setPointer(0);
        this.addContainerEvents();
    }

    setPointer(position) {
        this.pointer
            .attr("transform", `translate(${((position * this.fontBoxWidth) - pointerWidth)},${this.placements.editor.pointer})`)
    }

    renderRuler() {
        this.rulerContainer.selectAll(".ruler").remove();
        this.rulerContainer
            .append("line")
            .attr("class", "ruler")
            .attr("x1", `0`)
            .attr("y1", 0)
            .attr("x2", `${this.$activeBoxContainer.width}`)
            .attr("y2", 0)
            .attr("fill", '#000')
            .style("stroke", '#000')
            .style("stroke-width", 1);
        this.drawTicks()
    }

    drawTicks() {
        const tickTextPositions = getRulerTickStep(this.sequenceLength, this.$activeBoxContainer.width, 30);
        const tickWidth = 1;
        const tickHeight = 10;
        this.rulerContainer.selectAll(".tickGroup").remove();

        this.characters.filter(n => n.charIndex % tickTextPositions === 0).forEach(t => {
            const tickPosition = (t.charIndex * this.fontBoxWidth)

            const tickGroup = this.rulerContainer
                .append("g")
                .attr("class", "tickGroup")
                .attr("transform", `translate(${tickPosition},0)`)

            tickGroup.append("line")
                .attr("clss", "tickLine")
                .attr("x1", 0)
                .attr("y1", -(tickHeight / 2))
                .attr("x2", 0)
                .attr("y2", (tickHeight / 2))
                .attr("fill", '#000')
                .style("stroke", '#000')
                .style("stroke-width", tickWidth);

            tickGroup.append("text")
                .attr("class", "tickText")
                .attr("x", 0)
                .attr("y", (tickHeight + 2))
                .attr("text-anchor", "middle")
                .style("font-size", ".5em")
                .style("fill", "#000")
                .text(t.charIndex);
        })
    }

    drawSlots() {
        const slotHeight = 10;
        let cartoonStart = 0;
        let temp_start = 0;
        let temp_end = 0;

        this.slotsContainer.selectAll(".slot").remove();

        this.slots.forEach(s => {
            if (s.dna_sequence.encodings.length) {
                const lastEncoded = s.dna_sequence.encodings[s.dna_sequence.encodings.length - 1];
                temp_end = this.crossMap.find(item => item.pk === lastEncoded.id).sequence.end;
                const slotLength = (temp_end - temp_start);

                const arrowLength = 2;
                const slotDirection = s.direction
                const [start, end, arrowSize, direction] = scaleAnnotationSize(0, slotLength, slotDirection, arrowLength, this.fontBoxWidth, this.fontBoxWidth, this.sequenceLength, true);
                const label = s.dna_sequence.name + " (" + s.dna_sequence.friendly_id + ")";
                const slotGroup = this.slotsContainer
                    .append("g")
                    .attr("class", "slot")
                    .attr("transform", `translate(${temp_start * this.fontBoxWidth},${this.placements.editor.slot})`)
                    .attr('data-toggle', 'virtual-popper')
                    .attr("data-virtual-popper-content", label)

                slotGroup
                    .append("path")
                    .attr("d", annotationPath(0, slotHeight, 0, end, direction, arrowSize, this.fontBoxWidth))
                    .style("fill", "#5bbce0")
                    .style("stroke", "#000")
                    .style("stroke-width", "1")
                    .style("opacity", .6)

                slotGroup
                    .append("line")
                    .attr("class", "slot")
                    .attr("x1", 0)
                    .attr("y1", 0)
                    .attr("x2", 0)
                    .attr("y2", linearPreviewHeight / 2)
                    .style("stroke", "#000")
                    .style("stroke-width", 1)
                    .style("stroke-dasharray", ("3, 3"))

                temp_start = temp_end;
            }
        })
    }

    addContainerEvents() {
        const self = this;
        this.mainBoxContainer.on("click", e => {
            const start = fixedMaxValue(Math.round(e.offsetX / this.fontBoxWidth), 1, this.sequenceLength - 1);

            this.rangeBases = {
                "start": start,
                "end": start,
                "length": 0,
            }
            this.setPointer(start);

            this.EventsTrigger("setOffsetScroll", {
                "end": this.rangeBases.end,
                "source": this.sourceObject
            });

            this.EventsTrigger("slide", "end");
            this.EventsTrigger("updateRender");

            this.EventsTrigger("selectRange", {
                start: this.rangeBases.start,
                end: this.rangeBases.end,
                source: this.sourceObject
            });
        })
    }

    selectRange(data) {
        const selectedBases = countSelectedBases(data.start, data.end, this.crossMap, data.source, paddingEditor);

        this.rangeBases = {
            "start": selectedBases.sequence.start,
            "end": selectedBases.sequence.end,
            "length": selectedBases.characters.length
        }
        this.setPointer(this.rangeBases.start)
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("selectRange", "selectRange", this);
        }
    }

}